import {
  CLOSED_LEADS,
  CONCRETED_OPERATIONS_INFORMATION,
  DONE_EVENTS,
  DONE_VISITS,
  CURRENCIES,
  DASHBOARD_TABS,
  INQUIRY_CATEGORIES,
  PENDING_REVIEW_VIEW,
  PROPERTIES_STATUS,
  PROPERTY_ADDED_CATEGORIES,
  PROPERTY_OPERATIONS,
  TASKS_OPTIONS,
  TRENDING_STATUS,
} from '@/components/Dashboard/constants';
import {
  addedPropertiesTypesOptions,
  agentsPerformanceStatusOptions,
  closedLeadsTypesOptions,
  concretedOperationsTypesOptions,
  contactTypesOptions,
  conversionRateStatusOptions,
  conversionTimeStatusOptions,
  conversionTimeTypesOptions,
  developmentConsultationsTypesOptions,
  doneVisitsTypesOptions,
  doneEventsTypesOptions,
  inquiryTypesOptions,
  productionRateStatusOptions,
  propertyConsultationsTypesOptions,
  reservationsCreatedTypesOptions,
  responseTimeTypesOptions,
} from '@/components/Dashboard/DashboardPerformance/PerformanceModals/variants/utils';

const initialState = {
  edition: {
    loading: true,
    active: false,
    tabs: null,
    entriesToTrack: [],
  },
  tabActive: DASHBOARD_TABS.TODO,
  refreshCount: 0,
  miniCards: {
    loading: true,
    hasFetched: false,
    error: false,
    contactsValue: 0,
    propertiesValue: 0,
    selectedStatusId: PROPERTIES_STATUS.AVAILABLE,
    developmentsValue: 0,
    allProperties: {
      available: 0,
      reserved: 0,
      to_be_cotized: 0,
    },
  },
  kpiCards: {
    inquiriesReceived: {
      loading: true,
      hasFetched: false,
      error: false,
      id: 'inquiriesReceived',
      value: 0,
      percentage_status: TRENDING_STATUS.NEUTRAL,
      variation: null,
      icon: null,
      cardSelector: '#inquiries-received',
      order: 1,
    },
    newContacts: {
      loading: true,
      hasFetched: false,
      error: false,
      id: 'newContacts',
      value: 0,
      percentage_status: TRENDING_STATUS.NEUTRAL,
      variation: null,
      icon: null,
      cardSelector: '#new-contacts',
      order: 2,
    },
    responseTime: {
      loading: true,
      hasFetched: false,
      error: false,
      id: 'responseTime',
      value: 0,
      percentage_status: TRENDING_STATUS.NEUTRAL,
      variation: null,
      icon: null,
      cardSelector: '#response-time',
      order: 3,
    },
    doneVisits: {
      loading: true,
      hasFetched: false,
      error: false,
      id: 'doneVisits',
      value: 0,
      percentage_status: TRENDING_STATUS.NEUTRAL,
      variation: null,
      icon: null,
      cardSelector: '#done-visits',
      order: 4,
    },
    conversionRate: {
      loading: true,
      hasFetched: false,
      error: false,
      id: 'conversionRate',
      value: 0,
      percentage_status: TRENDING_STATUS.NEUTRAL,
      variation: null,
      icon: null,
      cardSelector: '#conversion-rate',
      order: 5,
    },
    conversionTime: {
      loading: true,
      hasFetched: false,
      error: false,
      id: 'conversionTime',
      value: 0,
      percentage_status: TRENDING_STATUS.NEUTRAL,
      variation: null,
      icon: null,
      cardSelector: '#conversion-time',
      order: 6,
    },
    addedProperties: {
      loading: true,
      hasFetched: false,
      error: false,
      id: 'addedProperties',
      value: 0,
      percentage_status: TRENDING_STATUS.NEUTRAL,
      variation: null,
      icon: null,
      cardSelector: '#added-properties',
      order: 7,
    },
    concretedOperations: {
      loading: true,
      hasFetched: false,
      error: false,
      id: 'concretedOperations',
      value: 0,
      percentage_status: TRENDING_STATUS.NEUTRAL,
      variation: null,
      icon: null,
      cardSelector: '#concreted-operations',
      order: 8,
    },
  },
  inquiriesReceived: {
    loading: true,
    hasFetched: false,
    error: false,
    selectedOption: INQUIRY_CATEGORIES.SOURCE,
    value: 1000,
    percentage_status: TRENDING_STATUS.NEUTRAL,
    trending: null,
    icon: null,
    options: {
      [INQUIRY_CATEGORIES.SOURCE]: {
        list: [],
        others: [],
      },
      [INQUIRY_CATEGORIES.OPERATION]: {
        list: [],
        others: [], // added just for structural consistency
      },
    },
    modalOpen: false,
    contacts: [],
  },
  conversionTime: {
    loading: true,
    hasFetched: false,
    error: false,
    mdn: 0,
    max: 0,
    min: 0,
    percentage_status: TRENDING_STATUS.NEUTRAL,
    variation: null,
    icon: null,
  },
  responseTime: {
    loading: true,
    hasFetched: false,
    error: false,
    mdn: 0,
    max: 0,
    min: 0,
    company_median_time: null,
    percentage_status: TRENDING_STATUS.NEUTRAL,
    variation: null,
    icon: null,
  },
  contactSource: {
    loading: true,
    hasFetched: false,
    error: false,
    empty: false,
    list: [],
    others: [],
    others_contacts_count: 0,
  },
  addedProperties: {
    loading: true,
    hasFetched: false,
    error: false,
    count: 0,
    percentage_status: TRENDING_STATUS.NEUTRAL,
    variation: null,
    icon: null,
    options: {
      [PROPERTY_ADDED_CATEGORIES.TYPE]: {
        labels: [],
        datasets: [],
      },
      [PROPERTY_ADDED_CATEGORIES.OPERATION]: {
        labels: [],
        datasets: [],
      },
    },
    selectedOption: PROPERTY_ADDED_CATEGORIES.TYPE,
  },
  concretedOperations: {
    loading: true,
    hasFetched: false,
    error: false,
    options: {
      [PROPERTY_OPERATIONS.SALE]: {
        value: 0,
        percentage_status: TRENDING_STATUS.NEUTRAL,
        variation: null,
        icon: null,
        labels: [],
        datasets: [],
      },
      [PROPERTY_OPERATIONS.RENT]: {
        value: 0,
        percentage_status: TRENDING_STATUS.NEUTRAL,
        variation: null,
        icon: null,
        labels: [],
        datasets: [],
      },
      [PROPERTY_OPERATIONS.COLLEAGUES]: {
        value: 0,
        percentage_status: TRENDING_STATUS.NEUTRAL,
        variation: null,
        icon: null,
        labels: [],
        datasets: [],
      },
    },
    selectedOption: PROPERTY_OPERATIONS.SALE,
  },
  concretedOperationsEvolution: {
    loading: true,
    hasFetched: false,
    error: false,
    value: 0,
    variation: null,
    percentage_status: TRENDING_STATUS.NEUTRAL,
    icon: null,
    labels: [],
    datasets: [],
    activeLegends: ['temporary', 'sale', 'rent'],
  },
  concretedOperationsSource: {
    loading: true,
    hasFetched: false,
    error: false,
    selectedOperation: PROPERTY_OPERATIONS.SALE,
    selectedInformation: CONCRETED_OPERATIONS_INFORMATION.QUANTITY,
    sale: {
      quantity: [],
      total_value_usd: [],
    },
    rent: {
      quantity: [],
      total_value_usd: [],
    },
  },
  doneVisits: {
    loading: true,
    hasFetched: false,
    error: false,
    value: 0,
    variation: null,
    percentage_status: TRENDING_STATUS.NEUTRAL,
    icon: null,
    options: {
      [DONE_VISITS.VISIT]: {
        list: [],
        others: [],
      },
      [DONE_VISITS.CLOSING_REASON]: {
        list: [],
        others: [],
      },
      [DONE_VISITS.QUALIFICATION]: {
        list: [],
      },
    },
    withoutClosingReason: {
      count: 0,
      percentage: 0,
    },
    withoutQualification: {
      count: 0,
      percentage: 0,
    },
    notClosed: {
      count: 0,
      percentage: 0,
    },
  },
  doneEvents: {
    loading: true,
    hasFetched: false,
    error: false,
    value: 0,
    variation: null,
    percentage_status: TRENDING_STATUS.NEUTRAL,
    icon: null,
    options: {
      [DONE_EVENTS.EVENT]: {
        list: [],
        others: [],
      },
      [DONE_EVENTS.CLOSING_REASON]: {
        list: [],
        others: [],
      },
      [DONE_EVENTS.QUALIFICATION]: {
        list: [],
      },
    },
    withoutClosingReason: {
      count: 0,
      percentage: 0,
    },
    withoutQualification: {
      count: 0,
      percentage: 0,
    },
    notClosed: {
      count: 0,
      percentage: 0,
    },
  },
  newContacts: {
    loading: true,
    hasFetched: false,
    error: false,
    value: 0,
    variation: null,
    percentage_status: TRENDING_STATUS.NEUTRAL,
    icon: null,
    labels: [],
    datasets: [],
  },
  conversionRate: {
    loading: true,
    hasFetched: false,
    error: false,
    rate: '0%',
    percentage_status: TRENDING_STATUS.NEUTRAL,
    variation: 0,
    icon: null,
    funnel: {
      new_contacts: 0,
      visits_percentage: '0%',
      visits_count: 0,
      reservations_percentage: '0%',
      reservations_count: 0,
      concreted_percentage: '0%',
      concreted_count: 0,
    },
    losses: {
      count: 0,
      percentage: '0%',
      percentage_status: TRENDING_STATUS.NEUTRAL,
      icon: null,
    },
  },
  closedLeads: {
    loading: true,
    hasFetched: false,
    error: false,
    count: 0,
    percentage_status: TRENDING_STATUS.NEUTRAL,
    variation: null,
    icon: null,
    options: {
      [CLOSED_LEADS.CLOSING_REASON]: {
        list: [],
        others: [],
      },
      [CLOSED_LEADS.QUALIFICATION]: {
        list: [],
        others: [],
      },
    },
    selectedOption: CLOSED_LEADS.CLOSING_REASON,
  },
  reservationsCreated: {
    loading: true,
    hasFetched: false,
    error: false,
    count: 0,
    percentage_status: TRENDING_STATUS.NEUTRAL,
    variation: null,
    icon: null,
    labels: [],
    datasets: [],
  },
  productionRate: {
    loading: true,
    hasFetched: false,
    error: false,
    rate: '0%',
    percentage_status: TRENDING_STATUS.NEUTRAL,
    variation: null,
    funnel: {
      appraisals_count: 0,
      added_count: 0,
      fallen_count: 0,
      added_percentage: '0%',
      fallen_percentage: '0%',
    },
  },
  doneVisitsEvolution: {
    loading: true,
    hasFetched: false,
    error: false,
    value: 0,
    variation: null,
    percentage_status: TRENDING_STATUS.NEUTRAL,
    icon: null,
    labels: [],
    datasets: [],
  },
  medianResponseTime: {
    loading: true,
    hasFetched: false,
    error: false,
    value: 0,
    variation: null,
    percentage_status: TRENDING_STATUS.NEUTRAL,
    icon: null,
    labels: [],
    datasets: [],
  },
  propertyConsultations: {
    loading: true,
    hasFetched: false,
    error: false,
    least_consulted: [],
    most_consulted: [],
  },
  developmentConsultations: {
    loading: true,
    hasFetched: false,
    error: false,
    least_consulted: [],
    most_consulted: [],
  },
  performanceModals: {
    newContacts: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchType: contactTypesOptions[0].value,
      searchTypeFlag: 0,
      searchStatus: null,
    },
    inquiriesReceived: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchType: inquiryTypesOptions[0].value,
      searchTypeFlag: 0,
    },
    doneVisits: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchType: doneVisitsTypesOptions[0].value,
      searchTypeFlag: 0,
    },
    doneEvents: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchType: doneEventsTypesOptions[0].value,
      searchTypeFlag: 0,
    },
    responseTime: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchType: responseTimeTypesOptions[0].value,
      searchTypeFlag: 0,
    },
    addedProperties: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchType: addedPropertiesTypesOptions[0].value,
      searchTypeFlag: 0,
    },
    conversionTime: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchType: conversionTimeTypesOptions[0].value,
      searchTypeFlag: 0,
      searchStatus: conversionTimeStatusOptions[1].value,
      lastGroupByBranch: false,
      groupByBranch: false,
    },
    conversionRate: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchStatus: conversionRateStatusOptions[1].value,
      lastGroupByBranch: false,
      groupByBranch: false,
    },
    productionRate: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      branches: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchStatus: productionRateStatusOptions[1].value,
      lastGroupByBranch: false,
      groupByBranch: false,
    },
    agentsPerformance: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      branches: [],
      page: 1,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchStatus: agentsPerformanceStatusOptions[1].value,
      lastGroupByBranch: false,
      groupByBranch: false,
    },
    concretedOperations: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchType: concretedOperationsTypesOptions[0].value,
      searchTypeFlag: 0,
    },
    propertyConsultations: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchType: propertyConsultationsTypesOptions[0].value,
      searchTypeFlag: 0,
    },
    developmentConsultations: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchType: developmentConsultationsTypesOptions[0].value,
      searchTypeFlag: 0,
    },
    closedLeads: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchType: closedLeadsTypesOptions[0].value,
      searchTypeFlag: 0,
    },
    reservationsCreated: {
      loading: false,
      hasFetched: false,
      sortBy: null,
      sortDirection: null,
      isOpen: false,
      list: [],
      page: 0,
      count: 0,
      has_next: true,
      searchQuery: '',
      searchType: reservationsCreatedTypesOptions[0].value,
      searchTypeFlag: 0,
    },
  },
  overviewLeads: {
    loading: true,
    hasFetched: false,
    error: false,
    empty: false,
    list: [],
    others: [],
  },
  pendingScheduledEvents: {
    loading: true,
    hasFetched: false,
    error: false,
    empty: false,
    list: [],
    others: [],
  },
  showings: {
    loading: true,
    hasFetched: false,
    error: false,
    empty: false,
    labels: [],
    datasets: [],
    event_type_ids: [],
  },
  overviewOperationStatistics: {
    loading: true,
    hasFetched: false,
    error: false,
    currencies: [],
    selectedCurrency: CURRENCIES.USD,
    selectedOperation: PROPERTY_OPERATIONS.SALE,
    sale: {},
    rent: {},
  },
  overviewPropertiesOperations: {
    loading: true,
    hasFetched: false,
    error: false,
    labels: [],
    datasets: [],
  },
  overviewPropertiesTypes: {
    pendent: true,
    loading: true,
    hasFetched: false,
    error: false,
    selectedOperation: PROPERTY_OPERATIONS.SALE,
    labels: [],
    datasets: [],
  },
  overviewPropertiesLocations: {
    loading: true,
    hasFetched: false,
    error: false,
    selectedOperation: PROPERTY_OPERATIONS.SALE,
    labels: [],
    datasets: [],
  },
  overviewConstructionAge: {
    loading: true,
    hasFetched: false,
    error: false,
    selectedOperation: PROPERTY_OPERATIONS.SALE,
    labels: [],
    datasets: [],
  },
  overviewEntryDate: {
    loading: true,
    hasFetched: false,
    error: false,
    selectedOperation: PROPERTY_OPERATIONS.SALE,
    labels: [],
    datasets: [],
  },
  overviewStaleProperties: {
    loading: true,
    hasFetched: false,
    error: false,
    totalCount: 0,
    headerUrl: null,
    labels: [],
    datasets: [],
  },
  overviewStaleContacts: {
    loading: true,
    hasFetched: false,
    error: false,
    totalCount: 0,
    headerUrl: null,
    labels: [],
    datasets: [],
  },
  overviewDevelopmentsTypes: {
    loading: true,
    hasFetched: false,
    error: false,
    labels: [],
    datasets: [],
  },
  overviewDevelopmentsLocations: {
    loading: true,
    hasFetched: false,
    error: false,
    labels: [],
    datasets: [],
  },
  overviewTasks: {
    loading: true,
    hasFetched: false,
    error: false,
    overviewTasksRefreshCount: 0,
    tasks: {
      [TASKS_OPTIONS.TODAY]: [],
      [TASKS_OPTIONS.EXPIRED]: [],
    },
    counts: {
      [TASKS_OPTIONS.TODAY]: 0,
      [TASKS_OPTIONS.EXPIRED]: 0,
    },
    selectedOption: TASKS_OPTIONS.TODAY,
  },
  events: {
    loading: true,
    hasFetched: false,
    error: null,
    empty: null,
    countToday: 0,
    nextEventTime: null,
    hasNow: false,
    items: [],
  },
  unassignedInquiries: {
    loading: true,
    hasFetched: false,
    error: null,
    empty: null,
    count: 0,
    inquiries: [],
  },
  visitsToConfirm: {
    loading: true,
    hasFetched: false,
    error: null,
    empty: null,
    count: 0,
    visits: [],
  },
  propertiesPendingReview: {
    loading: true,
    hasFetched: false,
    error: null,
    redirectUrl: null,
    [PENDING_REVIEW_VIEW.NEW]: { empty: null, count: 0, items: [] },
    [PENDING_REVIEW_VIEW.MODIFIED]: { empty: null, count: 0, items: [] },
  },
  developmentsPendingReview: {
    loading: true,
    hasFetched: false,
    error: null,
    redirectUrl: null,
    [PENDING_REVIEW_VIEW.NEW]: { empty: null, count: 0, items: [] },
    [PENDING_REVIEW_VIEW.MODIFIED]: { empty: null, count: 0, items: [] },
  },
  qprecoMarketplace: {
    loading: true,
    hasFetched: false,
    error: null,
    empty: null,
    enabled: true,
    selectedOperation: PROPERTY_OPERATIONS.SALE,
    operations: {},
  },
  marketplaceRegistrationQuality: {
    loading: true,
    hasFetched: false,
    error: null,
    empty: null,
    enabled: true,
    count: null,
    levels: [],
    redirectUrl: null,
  },
  pendingContacts: {
    loading: true,
    hasFetched: false,
    count: 0,
    error: null,
    empty: null,
    contacts: [],
  },
  pendingLeads: {
    loading: true,
    hasFetched: false,
    count: 0,
    error: null,
    empty: null,
    leads: [],
  },
  pendingReservations: {
    loading: true,
    hasFetched: false,
    count: 0,
    error: null,
    empty: null,
    reservations: [],
  },
  portalsNotifications: {
    loading: true,
    hasFetched: false,
    total_errors: 0,
    total_alerts: 0,
    error: null,
    empty: null,
    portals: [],
    properties: [],
  },
  exclusiveProperties: {
    loading: true,
    hasFetched: false,
    error: null,
    empty: null,
    count: 0,
    properties: [],
  },
  expiringRentProperties: {
    loading: true,
    hasFetched: false,
    error: null,
    empty: null,
    count: 0,
    properties: [],
  },
  filters: {
    loadingAgents: true,
    loadingBranches: true,
    errorAgents: null,
    errorBranches: null,
    companyAgents: [],
    selectAgents: [],
    selectBranches: [],
    selectedIds: [],
    filterBy: null,
  },
};

export default initialState;
